<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'Profile' | lang }}</div>
    </header>
    <div>
    
      <anagrafica  :onlyread=onlyread  /> 
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import anagrafica from '@/components/Anagrafica.vue'


export default {
  name: 'AnagraficaPage',
  props:['onlyread'],
  mixins: [ page ],
  components: {anagrafica },
  data () {
    return {

    }
  },
  computed: {},
  methods: {
    logout () {
      this.isLogged = false
      this.back()
    }
  },
  beforeDestroy () {},
  mounted () {
  },
  watch: {}
}
</script>

<style lang="scss">


</style>
